/* src/app/forms/orders-view/orders-view.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.tabcontent {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.content {
  padding: 5px;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}
.mktplace {
  overflow: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.mat-mdc-tab-group {
  height: 100%;
}
:host ::ng-deep .custom-tabs {
}
:host ::ng-deep .custom-tabs .mat-tab-body-wrapper {
  height: 100%;
}
/*# sourceMappingURL=orders-view.component.css.map */
